export default __webpack_public_path__ + "static/media/cereales.85944366.svg";